import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { PayDayProductModel } from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_TC,
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';

@Component({
  selector: 'app-configuration-values',
  templateUrl: './configuration-values.component.html',
  styleUrls: ['./configuration-values.component.scss'],
})
export class ConfigurationValuesComponent implements OnInit {
  formValues: FormGroup;
  max_value: number;
  value_visa: number;
  value_master: number;
  value_visalf: number;
  err_msn = false;
  state_master = false;
  state_visa = false;
  state_visalf = false;
  state_next = true;
  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };

  payDayProductModel: PayDayProductModel = {
    selectedPayDay: {},
    selectedProduct: {},
  } as PayDayProductModel;
  firmlyApproved = false;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abrecuentasService: AbreCuentasService,
    private bitacoraService: BitacoraService,
    private navigationService: NavigationService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private taggingService: TaggingService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
    this.firmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
    this.setPayDayProductModel();
    this.get_ConfigurationValues();
  }

  /**
   * Se inicializa el formulario en vacío, solo se validan los valores mínimos de cada uno.
   */
  ngOnInit() {
    if (this.firmlyApprovedService.isFirmlyApproved() && this.abrecuentasService.getProductsSelects().length === 1) {
      this.sendConfigurationValuesPageLoad();
    }
    this.formValues = new FormGroup({});
    if (this.state_master) {
      this.formValues.addControl(
        'value_master',
        new FormControl(this.value_master,
          [Validators.required, Validators.min(1000000)]),
      );
    }
    if (this.state_visa) {
      this.formValues.addControl(
        'value_visa',
        new FormControl(this.value_visa,
          [Validators.required, Validators.min(1000000)]),
      );
    }
    if (this.state_visalf) {
      this.formValues.addControl(
        'value_visalf',
        new FormControl(this.value_visalf,
          [Validators.required, Validators.min(2000000)]),
      );
    }
    this.enableNextButton();
  }
  /**
   * Se capturan el monto aprobado y se activan las franquicias seleccionadas para distribuir el monto entre ellas.
   */
  async setPayDayProductModel() {
    this.payDayProductModel = await this.abrecuentasService.getPayDayProductSelected();
    if (this.firmlyApproved) {
      const product = this.firmlyApprovedService.getProduct_FirmlyApproved(BUSINESS_CONST.PRODUCT_CODE_TCR);
      this.max_value = product ? parseInt(product.amount, 10) : 0;
    } else {
      let pcoModel: any = await this.abrecuentasService.getPcoModel();
      console.log(pcoModel);
      if (this.abrecuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        this.max_value = parseInt(
          pcoModel.granted_product.limit_amount.amount.toString(),
          0,
        );
      }
      if (this.abrecuentasService.getproductSelected().product_type === BUSINESS_CONST.MULTI) {
        pcoModel.granted_product_multi.forEach(element => {
          if (element.product_type === 'creditCard') {
            this.max_value = parseInt(element.limit_amount.amount.toString(), 0);
          }
        });
      }
    }

    if (Object.entries(this.payDayProductModel).length === 0) {
      this.payDayProductModel = {
        selectedPayDay: {},
        selectedProduct: {},
      };
    } else {
      const listProductos = this.payDayProductModel['selectedProduct'];
      listProductos.forEach((element: any) => {
        if (element.elementId === 1) {
          this.state_master = true;
        } else if (element.elementId === 2) {
          this.state_visa = true;
        } else if (element.elementId === 3) {
          this.state_visalf = true;
        }
      });
    }
  }

  async get_ConfigurationValues() {
    const configValuesModel = this.abrecuentasService.getConfigurationValues();
    this.value_master = configValuesModel['value_master']
      ? parseInt(configValuesModel['value_master'].toString(), 0)
      : 0;
    this.value_visa = configValuesModel['value_visa']
      ? parseInt(configValuesModel['value_visa'].toString(), 0)
      : 0;
    this.value_visalf = configValuesModel['value_visalf']
      ? parseInt(configValuesModel['value_visalf'].toString(), 0)
      : 0;
  }
  /**
   * se capturan el monto aprobado y se activan las franquicias seleccionadas para distribuir el monto entre ellas.
   * La sumatoria de los cupos por franquicia no debe estar por encima, ni por debajo del cupo aprobado por PCO o
   * modificado por el cliente, en caso de que el valor difiera debe mostrar mensaje de error y el call to action
   * continuar debe estar deshabilitado
   */

  enableNextButton() {
    const sum =
      (this.formValues.value['value_visa']
        ? parseInt(this.formValues.value.value_visa, 0)
        : 0) +
      (this.formValues.value['value_master']
        ? parseInt(this.formValues.value['value_master'], 0)
        : 0) +
      (this.formValues.value['value_visalf']
        ? parseInt(this.formValues.value['value_visalf'], 0)
        : 0);
    this.abrecuentasService.setConfigurationValues(this.formValues.value);
    if (sum === this.max_value && this.formValues.valid) {
      this.err_msn = false;
      this.state_next = false;
      return;
    }
    if (sum === this.max_value && !this.formValues.valid) {
      this.err_msn = false;
      this.state_next = true;
      return;
    }
    if (sum !== this.max_value && this.formValues.invalid) {
      this.err_msn = false;
      this.state_next = true;
      return;
    }
    if (sum !== this.max_value && !this.formValues.invalid) {
      this.err_msn = true;
      this.state_next = true;
    }
  }

  /**
   * Se guardar marcas en bitácora y se genera la navegación  al siguiente componente
   */
  next() {
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    this.payDayProductModel['selectedProduct'].forEach((element: any) => {
      if (element.elementId === 1) {
        this.bitacoraService.saveDataInBitacora(
          'value_master_' + this.formValues.value['value_master'].toString(),
        );
        this.setValues_FirmlyApproved(BUSINESS_CONST.MASTERCARD, parseInt(this.formValues.value['value_master'], 10));
      } else if (element.elementId === 2) {
        this.bitacoraService.saveDataInBitacora(
          'value_visa_' + this.formValues.value['value_visa'].toString(),
        );
        this.setValues_FirmlyApproved(BUSINESS_CONST.VISA, parseInt(this.formValues.value['value_visa'], 10));
      } else if (element.elementId === 3) {
        this.bitacoraService.saveDataInBitacora(
          'value_visalf_' + this.formValues.value['value_visalf'].toString(),
        );
        this.setValues_FirmlyApproved(BUSINESS_CONST.VISALM, parseInt(this.formValues.value['value_visalf'], 10));
      }
    });
    this.abrecuentasService.setConfigurationValues(this.formValues.value);
    console.log('Configuration values: ', this.abrecuentasService.getConfigurationValues());
    this.navigationService.nextStep('200');
  }

  /**
   * Función que permite modificar los montos para cada una de las
   * franquincias seleccionadas por el usuario y que son de TCR del
   * Aprobado En Firme
   */
  setValues_FirmlyApproved(brand: string, value: number) {
    if (!this.firmlyApproved) {
      return ;
    }
    this.firmlyApprovedService.getDetailProductsMulti(
      BUSINESS_CONST.PRODUCT_TYPE_TC,
    ).find(card => card.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && card.brand === brand).limit_amount.amount = value;
    console.log('Valores del Aprobado TC: ', this.firmlyApprovedService.getDetailProductsMulti());
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendConfigurationValuesPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv10pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv10pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv10pageFamily.path,
        value: PAGEVIEW_FA.pv10pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv10subFamily.path,
        value: PAGEVIEW_FA.pv10subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv10pageAction.path,
        value: PAGEVIEW_FA.pv10pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv10pageid.path,
        value: ConfigurationValuesComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv10transactionName.path,
        value: `${PAGEVIEW_FA.pv10transactionName.value.slice(0, -2)}${productsType[this.abrecuentasService.getProductsSelects()[0].product]}`,
      },
      {
        path: PAGEVIEW_FA.pv10transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv10transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_TC.pv10E1setData.pv10E1transactionTransactionStep.path,
        value: EVENT_FA_TC.pv10E1setData.pv10E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv10E1setData.pv10E1transactionName.path,
        value: EVENT_FA_TC.pv10E1setData.pv10E1transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv10E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_TC.pv10E2setData.pv10E2transactionTransactionStep.path,
        value: EVENT_FA_TC.pv10E2setData.pv10E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv10E2setData.pv10E2transactionName.path,
        value: EVENT_FA_TC.pv10E2setData.pv10E2transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv10E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }
}
